module.exports = __webpack_public_path__ + "static/img/6.90f7877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/6.png
// module id = wBoo
// module chunks = 1 3